import { render, staticRenderFns } from "./CvrPermStatus.vue?vue&type=template&id=8141bb1e&"
import script from "./CvrPermStatus.vue?vue&type=script&lang=js&"
export * from "./CvrPermStatus.vue?vue&type=script&lang=js&"
import style0 from "./CvrPermStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CvrPermStatus.vue"
export default component.exports